  import * as React from 'react';

  
  import Dialog from '@mui/material/Dialog';
  import DialogTitle from '@mui/material/DialogTitle';
  import DialogContent from '@mui/material/DialogContent';
  import StocksContext from '../../../contexts/StocksContext';
  import StatusContext from '../../../contexts/StatusContext';

  import IconButton from '@mui/material/IconButton';
  import CloseIcon from '@mui/icons-material/Close';
  import StocksSymbols from './StocksSymbols'

 
  import './stockssymbols.css';
  
  export const DialogSymbols = () => {

  const {
  changeLanguageEnglish,
          
  } = React.useContext(StatusContext);

  const {
   showSymbolsDialog,
   setShowSymbolsDialog,
 
  } = React.useContext(StocksContext);


const styles = {
  container1: {
    alignItems: 'center', // Center vertically
 
    padding: '10px',
    marginBottom: '10px',
    width: '100%',
    border:'none',
    cursor: 'pointer',
    //backgroundColor: (index) => (hoveredIndex === index ? 'lightcoral' : 'lightblue'), // Change color based on hovered index
    transition: 'background-color 0.3s ease', // Optional transition for smooth effect
    },

    item: {
      
      alignItems: 'center', // Center vertically
      textAlign: 'center',
      color: 'maroon',
      borderRadius: '5px',
     
      padding: '5px',
      marginBottom: '10px',
      width: '100%',
      border:'none',
      cursor: 'pointer',
      //backgroundColor: (index) => (hoveredIndex === index ? 'lightcoral' : 'lightblue'), // Change color based on hovered index
      transition: 'background-color 0.3s ease', // Optional transition for smooth effect
      },
  title: {
    display: 'flex',
    color: 'rgb(138, 57, 57)',
    fontSize: '26px',
    marginTop:'-25px',
    marginBottom: '-15px',
    justifyContent: 'center',
  },
  
  text: {
  
    color: 'rgb(138, 57, 57)',
    fontSize: '16px',
    fontWeight: '500',
    marginBottom:'15px',
    justifyContent: 'center',
    textAlign:'center',
  },
  savebutton: {
   
    justifyContent: 'center',
  }
 
}
  
  const handleClose = (event, reason) => {
   
  
    if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
      // Handle the backdrop click event here
      return
    }

    //const filteredSymbols = stockSymbols.filter(symbol => symbol !== '');
    //setStockSymbols([...filteredSymbols])
   //handleSymbols()
    //setError('');
    setShowSymbolsDialog(false)
  
  };


    return (
    
      <React.Fragment>
    
          <Dialog
            open={showSymbolsDialog}
          
            PaperProps={{
              component: 'form',
              onSubmit: (event) => {
                event.preventDefault();
                const formData = new FormData(event.currentTarget);
                const formJson = Object.fromEntries(formData.entries());
                const email = formJson.email;
                console.log(email);
                
              },
            }}
          >

          <DialogTitle style = {{fontSize:'14px'}}>
         
          </DialogTitle>

       
      
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
          <CloseIcon />
        </IconButton>

        <br></br>
      
        <DialogTitle style = {styles.title}>
            {changeLanguageEnglish('stocks', 'dialogsymbolstitle')}
         
        </DialogTitle>
      
          <DialogContent dividers>
          
        
          <StocksSymbols />
      
          </DialogContent>
        </Dialog>
      </React.Fragment>
    )
  
    
  }
